const getKeyByOptionIds = (optionIds: string[]): string => {
  return optionIds.sort().join('#')
}

export {getKeyByOptionIds}
